module.exports = __webpack_public_path__ + "static/header_small-00d0ad6f66558d23d20a2198efc7439f.png";